import { render, staticRenderFns } from "./BannerComponent.vue?vue&type=template&id=f88d5b5e&"
import script from "./BannerComponent.vue?vue&type=script&lang=js&"
export * from "./BannerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports